<!--宠物视频-->
<template>
  <div class="pet-container">
    <div class="flex ac cr fs18">
      <div class="mr15" :style="{ color: source==2 ? '#01FBF5' : theme.homeColor2}" @click="handleChooseTitle(2)">
        AI宠物库
      </div>
      <div :style="{ color: source==1 ? '#01FBF5' : theme.homeColor2}" @click="handleChooseTitle(1)">我上传的</div>
    </div>
    <!--    上传的-->
    <div class="my-up-box" v-if="source==1">
      <div class="flex as fw">
        <div class="upload-box cr">
          <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/4.2_Icon_Upload.png" alt=""
               @click="handleOpenDialog">
          <div class="mt15 mb15">上传照片, 打造毛孩专属片场</div>
          <el-button type="primary" icon="el-icon-plus" @click="handleOpenDialog"
                     style="background: linear-gradient( 312deg, #6C14FF 0%, #01FBF5 100%);border: none">快速上传
          </el-button>
        </div>
        <div class="my-up-img-box" v-for="(item,index) in upImageList" :key="index">
          <div class="img-box" :style="{backgroundImage: 'url(' + item.url + ')', backgroundRepeat:'no-repeat'}"
               @mouseover="handleMouse(item)" @mouseleave="handleMouseOut(item)">
            <div v-if="hoverId==item.id">
              <div class="cwcj-btn-box cr" @click.stop="handleCreate(item)">+创建视频</div>
              <div class="close-box cr" @click.stop="handleDelete(item)">
                <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/14.1.2_Icon_Del.png" alt="">
              </div>
            </div>
          </div>
          <div class="up-title cr tc te2 mt10">{{item.name}}</div>
        </div>
      </div>
    </div>
    <!--  照片库  -->
    <div class="my-up-box" v-if="source==2">
      <div class="flex as fw">
        <div class="my-up-img-box" v-for="(item,index) in upImageList" :key="index">
          <div class="img-box" :style="{backgroundImage: 'url(' + item.url + ')', backgroundRepeat:'no-repeat'}"
               @mouseover="handleMouse(item)" @mouseleave="handleMouseOut(item)">
            <div v-if="hoverId==item.id">
              <div class="cwcj-btn-box cr" @click.stop="handleCreate(item)">+创建视频</div>
            </div>
          </div>
          <div class="up-title cr tc te2 mt10">{{item.name}}</div>
        </div>
      </div>
    </div>

    <el-dialog title="上传宠物照片" :visible.sync="outerVisible" width="800px">
      <el-dialog
        width="30%"
        title="《本平台视频克隆使用规范》"
        :visible.sync="innerVisible"
        append-to-body>
        <div v-if="content" v-html="content"></div>
        <ul v-else>
          <li>本声明将帮助您更好的在【欢迎来到{{site_title}}】平台（下称“本平台”）使用相关工具上传和管理您的作品。您若上传作品，即视为您以充分知悉并充分接受以下内容：</li>
          <li>您作为使用者在本平台上传、发布的作品，应具有独立、完整的知识产权，不得侵犯他人知识产权等任何权利。</li>
          <li>
            您在使用本平台及上传、发布作品时，应当自觉遵守国家法律、法规，遵守公共秩序，尊重社会公德、社会主义制度、国家利益、公民合法权益、道德风尚和信息真实性等要求。如有违反，一经本平台发现将根据违规程度采取包括但不限于删除、下架、禁止发布内容、封禁账号等处理方式。如造成恶劣影响或涉嫌违法犯罪的，本平台将有权向有关管理机关或公安机关提交相关内容，并配合进行调查。
          </li>
          <li>
            若您上传的作品及作品中的素材（包括但不限于创意、文本、肖像、音频、图片、视频等）侵犯了任何第三方权利，本平台均有权在收到相关侵权投诉后对该被投诉的作品或用户账号依据相应规则，采取包括但不限于下架、警告、封禁账号等处理方式。
          </li>
        </ul>
      </el-dialog>

      <div class="fs14" style="color: #333333;font-weight: 500;">
        <div class="mb05"><span style="color: red">*</span> 宠物照片名称</div>
        <el-input v-model="name" placeholder="请输入照片名称，如：嘟嘟是小黄"></el-input>
      </div>

      <div class="mt15 fs14" style="color: #333333;font-weight: 500;">
        <div class="mb05"><span style="color: red">*</span>照片素材</div>
        <div v-if="!upImageUrl">
          <el-upload
            ref="upload"
            :action="uploadUrl"
            :show-file-list="false"
            accept=".png,.jpg"
            :on-success="handleFileUpSuccess"
            :on-error="handleFileUpError"
            :on-remove="handleRemove"
            :before-upload="beforeAvatarUpload"
            multiple
            :limit="1"
            :headers="myHeaders"
            :data="needParam"
          >
            <template>
              <div class="dia-upload-box">
                <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/4.2_Icon_Upload.png" alt="">
                <div>请上传一张宠物照片用于创作视频</div>
              </div>
            </template>
          </el-upload>
        </div>
        <div v-else class="have-image-box">
          <img :src="upImageUrl" alt="">
          <div class="reset-btn-box">
            <el-button type="primary" icon="el-icon-refresh" @click="handleResetUp"
                       style="background: linear-gradient( 312deg, #6C14FF 0%, #01FBF5 100%);border: none">重新上传
            </el-button>
          </div>

        </div>
      </div>


      <div slot="footer" class="dia-upload-footer">
        <div class="flex ac jb">
          <div class="flex ac">
            <img v-if="gxState" class="gx-img"
                 src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/2.4_Icon_choose.png" alt=""
                 @click="gxState=!gxState">
            <img v-else class="gx-img"
                 src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/2.4_Icon_unchoose.png" alt=""
                 @click="gxState=!gxState">
            <div> 我已阅读并同意 <span style="color: #333333" @click="innerVisible = true">《本平台视频克隆使用规范》</span></div>
          </div>
          <div>
            <el-button @click="outerVisible = false">取 消</el-button>
            <el-button type="primary" style="background: #6C14FF;border-color: #6C14FF" @click="handleSumbit">提交
            </el-button>
          </div>
        </div>


      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {delPhoto, getPhoto, postPhoto, protocol, uploadComplete, uploadSign} from '../api/user'

  export default {
    name: '',
    data() {
      return {
        source: 2,
        needParam: {},
        uploadUrl: '',
        uploadDir: '',
        outerVisible: false,
        innerVisible: false,
        name: '',
        file_id: '',
        upImageUrl: '',
        upImageList: [],
        hoverId: null,
        site_title: '',
        gxState: true,
        content: ''
      }
    },
    computed: {
      myHeaders() {
        return {'x-token': window.localStorage.getItem('xcToken') || ''}
      },
      theme() {
        return this.$store.getters.getTheme;
      }
    },
    created() {
      if (window.localStorage.getItem('siteJson')) {
        const siteJson = JSON.parse(window.localStorage.getItem('siteJson'))
        this.site_title = siteJson.siteTitle
      }
      if(this.$route.query.type){
        this.source = 1
        this.outerVisible = true
      }
      this.getPhotoList()
      this.getUploadSign()
      // 获取协议
      this.getProtocol()

      // if (this.source == 2) {
      //   this.getUploadSign()
      // }
    },
    methods: {
      // 获取协议
      getProtocol() {
        protocol().then(res => {
          this.content = this.changeText(res.data.content)
        })
      },
      changeText(val) {
        const imageRegex = /<img((?![^>]*?style)[^>]*)>/gi;
        const replacedText = val.replace(imageRegex, (match) => {
          return `<img ${match.slice(0, -1)} style="width: 100%;">`;
        });
        return replacedText;
      },
      handleChooseTitle(val) {
        this.source = val
        this.upImageList = []
        this.getPhotoList()
      },
      getPhotoList() {
        getPhoto({source: this.source, type: 2, page: 0, limit: 0}).then(res => {
          this.upImageList = res.data.list
          // console.log('res', res)
        })
      },
      getUploadSign() {
        uploadSign({file_type: 'image'}).then(res => {
          this.uploadUrl = res.data.host
          this.uploadDir = res.data.dir
          this.needParam = {
            'OSSAccessKeyId': res.data.access_key_id,
            'policy': res.data.policy,
            'signature': res.data.signature,
          }
        })
      },
      handleMouse(item) {
        this.hoverId = item.id
      },
      handleMouseOut() {
        this.hoverId = ''
      },
      handleOpenDialog() {
        this.outerVisible = true
      },

      beforeAvatarUpload(file) {
        this.loading = this.$loading({
          lock: true,
          text: '上传中,请等待...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.6)'
        });
        const that = this
        var file_type = file.name.split('.').slice(-1)
        var file_name = that.uploadDir + Date.parse(new Date()) + '' + parseInt(Math
          .random() * 100) + '.' + file_type
        that.needParam.key = file_name
        that.uploadSize = file.size

        const fileExtension = file.name.split('.').pop().toLowerCase()
        // if (fileExtension == 'mp3' || fileExtension == 'm4a' || fileExtension == 'wav') {
        //   return true
        // } else {
        //   that.$message.error('请上传MP3/M4A/WAV格式的音频')
        //   return false
        // }
      },
      handleFileUpSuccess(file) {
        const url = `${this.uploadUrl}/${this.needParam.key}`
        uploadComplete({
          file_type: 'image',
          size: this.uploadSize,
          url: url
        }).then(res => {
          if (res.data.url && res.data.file_id) {
            this.file_id = res.data.file_id
            this.upImageUrl = res.data.url
            this.$message.success('上传成功')
            this.loading.close();
          }
        }).catch(() => {
          this.loading.close();
        })

        this.$refs.upload && this.$refs.upload.clearFiles();
      },
      handleRemove() {
        this.upImageUrl = ''
        this.$refs.upload && this.$refs.upload.clearFiles();
      },
      handleResetUp() {
        this.upImageUrl = ''
        this.file_id = ''
        this.$refs.upload && this.$refs.upload.clearFiles();
      },

      handleFileUpError() {
        this.$message.error('上传失败，请重新上传')
        this.loading.close();
      },
      handleSumbit() {
        if (this.name.trim() == '') {
          this.$message.error('请填写宠物名称！')
          return false
        }
        if (this.uploadUrl == '' || this.file_id == '') {
          this.$message.error('请上传宠物图片！')
          return false
        }
        postPhoto({name: this.name, file_id: this.file_id, type: 2}).then(res => {
          this.$message.success(res.msg)
          this.upImageUrl = ''
          this.name = ''
          this.outerVisible = false
          this.getPhotoList()
        }).catch(error => {
          this.$message.error(error.msg)
        })
      },
      handleCreate(item) {
        this.$router.push({
          path: '/pet/establish',
          query: {
            id: item.id,
            source: this.source
          }
        })
      },
      handleDelete(item) {
        this.$confirm('此操作将永久删除该宠物图片, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delPhoto({id: item.id}).then(() => {
            this.$message.success('删除成功')
            this.getPhotoList()
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }

    },
    /**加载完组件时执行(加载完成之后执行)*/
    mounted() {
    },
  }
</script>

<style lang="scss" scoped>
   .pet-container::-webkit-scrollbar {
     display: none !important;
     width: 0 !important;
     height: 0 !important;
   }
  .pet-container {
    width: 100%;
    height: calc(100vh - 50px);
    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    padding: 33px 40px;
    font-size: 16px;

    font-weight: 500;
    color: #FAFAFA;
    text-align: left;

  }

  .choosedTitle {
    color: #01FBF5;
  }

  .my-up-box {
    margin-top: 18px;

    .upload-box {
      width: 243px;
      height: 392px;
      background: #131724;
      border-radius: 8px;
      border: 1px solid rgba(151, 151, 151, 0.5);
      padding-top: 140px;
      font-weight: 400;
      font-size: 14px;
      color: #FAFAFA;
      text-align: center;
      margin-right: 36px;

      img {
        cursor: pointer;
        width: 36px;
        height: 36px;
      }
    }

    .my-up-img-box {
      width: 243px;
      height: 432px;

      margin-right: 26px;
      margin-bottom: 16px;

      .img-box {
        border: 1px solid rgba(151, 151, 151, 0.5);
        border-radius: 8px;
        width: 243px;
        height: 392px;
        background-size: cover; /* 保持宽高比，同时填充父容器 */
        background-position: center; /* 背景图片居中 */
        position: relative;

        .cwcj-btn-box {
          position: absolute;
          left: 12px;
          bottom: 16px;

          width: 219px;
          height: 40px;
          background: linear-gradient(312deg, #6C14FF 0%, #01FBF5 100%);
          border-radius: 6px;

          font-weight: 500;
          font-size: 14px;
          color: #FFFFFF;
          line-height: 40px;
          text-align: center;
        }

        .close-box {
          position: absolute;
          right: 12px;
          top: 12px;
          width: 32px;
          height: 32px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .up-title {
        font-weight: 400;
        font-size: 14px;
        color: #FAFAFA;
        padding: 0 10px;
      }
    }
  }

  .dia-upload-box {
    width: 760px;
    height: 200px;
    border: 1px solid #DCDFE6;
    border-radius: 6px;
    padding-top: 70px;

    img {
      width: 36px;
      height: 36px;
      display: block;
      margin: 0 auto 10px;
    }
  }

  .have-image-box {
    width: 760px;
    height: 200px;
    border: 1px solid #DCDFE6;
    border-radius: 6px;
    position: relative;

    img {
      height: 100%; /* 图片高度撑满父容器 */
      width: auto;
      display: block;
      margin: 0 auto;
      object-fit: contain
    }

    .reset-btn-box {
      position: absolute;
      left: calc(50% - 50px);
      top: 50%;
    }

  }

  .dia-upload-footer {
    cursor: pointer;
    font-weight: 400;
    font-size: 14px;
    color: #999999;

    .gx-img {
      width: 18px;
      height: 18px;
      display: block;
      margin-right: 4px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pet.vue